class DlProductVariantPickerH extends HTMLElement {
    constructor() {
        super();

        this.productH = this.closest('dl-product-h');
        this.featuredImages = this.productH.querySelectorAll('.dl-product-media-gallery-h-main-first img');
        this.featuredImagesM = this.productH.querySelectorAll('.dl-product-media-gallery-m-h-main-item-first img');
        this.mediaGalleryM = this.productH.querySelector('dl-product-media-gallery-m-h');
        this.addtoCartBar = this.productH.querySelector('dl-product-addtocart-bar-h');

        this.options = this.querySelectorAll('.dl-options');
        this.optionsItems = this.querySelectorAll('.dl-option-item');
        this.optionsImages = this.querySelectorAll('.dl-option-item img');

        this.productInfo = this.productH.querySelector('dl-product-info-h');
        this.priceContainer = this.productInfo.querySelector('.dl-product-info-h-price');
        this.priceOriginalContainer = this.productInfo.querySelector('.dl-product-info-h-price-original');

        this.bindEvents();
        this.checkOptionAvaiable();
    }

    bindEvents() {
        this.optionsItems.forEach(option => {
            option.addEventListener('click', this.optionClick.bind(this));
        })
    }

    optionClick(e) {
        let elem = e.currentTarget
        let options = elem.closest('.dl-options');
        options.querySelectorAll('.dl-option-item').forEach(option => {
            option.classList.remove('dl-selected');
        });
        elem.classList.add('dl-selected');

        let v = this.getSelectVariant();
        this.changeVariantImage();
        this.changeVariantPrices(v);
        this.changeFeatureImage(v.id);
        this.checkOptionAvaiable();
        this.changeUrl(v.id);
        this.changeVariantAvaiable();
        this.changeAddToCartBarAvaiable(v.available);
        this.productH.setTotal();
    }

    getSelectOptionValues() {
        let result = [];
        this.querySelectorAll('.dl-option-item.dl-selected').forEach(option => {
            result.push(option.dataset.dlValue);
        });
        return result;
    }

    getSelectVariant() {
        let result = null;
        let selected_options_value = this.getSelectOptionValues();
        selected_options_value = selected_options_value.sort();
        dl_product.variants.forEach(variant => {
            if (result == null) {
                let variantOptionsSort = variant.options.sort();
                let match = true;
                for (let i = 0; i < selected_options_value.length; i++) {
                    if (selected_options_value[i] !== variantOptionsSort[i]) {
                        match = false;
                        break;
                    }
                }
                if (match) {
                    result = variant;
                }
            }
        });
        return result;
    }

    changeVariantImage() {
        let selected_options_value = this.getSelectOptionValues();
        this.optionsImages.forEach(image => {
            image.classList.remove('dl-show');
            let option_selected_value = image.closest('.dl-options').querySelector('.dl-selected').dataset.dlValue;
            let selected_options_value_without_current_selected = selected_options_value.filter(item => item !== option_selected_value).sort();
            let option_value = image.dataset.dlValue;
            let option_variant_options_value_without_current = image.dataset.dlVariantOptionsValue.split(';').filter(item => item !== option_value).sort();
            if (selected_options_value_without_current_selected.every((v, i) => v === option_variant_options_value_without_current[i])) {
                image.classList.add('dl-show');
            }
        })
    }

    changeVariantAvaiable() {
        let selected_options_value = this.getSelectOptionValues();
        this.optionsItems.forEach(option => {
            let option_avaiable = false;
            let option_base = option.closest('.dl-options');
            let option_selected_value = option_base.querySelector('.dl-option-item.dl-selected').dataset.dlValue;
            let selected_options_value_without_current_selected = selected_options_value.filter(item => item !== option_selected_value);
            let option_value = option.dataset.dlValue;
            selected_options_value_without_current_selected.push(option_value);
            let current_options_value = selected_options_value_without_current_selected.sort().join(';');
            let current_variant = dl_product.variants.find(variant => variant.options.sort().join(';') == current_options_value);
            if (current_variant.available) {
                option.classList.remove('dl-disabled')
            } else {
                option.classList.add('dl-disabled')
            }
        })
    }

    changeVariantPrices(variant) {

        this.priceContainer.innerHTML = formatMoney(variant.price);

        if (variant.compare_at_price > variant.price) {
            this.priceOriginalContainer.innerHTML = formatMoney(variant.compare_at_price);
            this.priceOriginalContainer.classList.add('dl-show');
            this.priceContainer.classList.add('dl-product-info-h-price-sale')
        } else {
            this.priceOriginalContainer.classList.remove('dl-show');
            this.priceContainer.classList.remove('dl-product-info-h-price-sale');
        }
    }

    changeAddToCartBarAvaiable(available) {
        if (available) {
            this.addtoCartBar.enabled();
        } else {
            this.addtoCartBar.disabled();
        }
    }

    changeFeatureImage(variant_id) {
        this.featuredImages.forEach(image => {
            let img_variant_id = image.dataset.dlVariantId;
            if (variant_id != img_variant_id) {
                image.classList.remove('dl-show');
            }
            else {
                image.classList.add('dl-show');
            }
        })

        this.featuredImagesM.forEach(image => {
            let img_variant_id = image.dataset.dlVariantId;
            if (variant_id != img_variant_id) {
                image.classList.remove('dl-show');
            }
            else {
                image.classList.add('dl-show');
            }
        });

        this.mediaGalleryM.glide.go('=0');
    }

    checkOptionAvaiable() {
        let selected_options_value = this.getSelectOptionValues();
        this.optionsItems.forEach(option => {
            let option_selected_value = option.closest('.dl-options').querySelector('.dl-selected').dataset.dlValue;
            let option_value = option.dataset.dlValue;
            let selected_options_value_without_current_selected = selected_options_value.filter(item => item !== option_selected_value);
            selected_options_value_without_current_selected.push(option_value)
            let selected_options_value_but_install_of_current = selected_options_value_without_current_selected.sort().join(';');
            let has_variant = false;
            dl_product.variants.forEach(variant => {
                let variant_option_values = variant.options.sort().join(';')
                if (selected_options_value_but_install_of_current == variant_option_values) {
                    has_variant = true;
                }
            })
            if (has_variant) {
                option.classList.remove('dl-hide');
            } else {
                option.classList.add('dl-hide');
            }
        })
    }

    changeUrl(variant_id) {
        let url = new URL(window.location.href);
        url.searchParams.set('variant', variant_id);
        window.history.replaceState({ path: url.href }, '', url.href);
    }

}
customElements.define('dl-product-variant-picker-h', DlProductVariantPickerH);

class DlProductQuantityH extends HTMLElement {
    constructor() {
        super();

        this.minus_btn = this.querySelector('.dl-product-quantity-h-minus');
        this.plus_btn = this.querySelector('.dl-product-quantity-h-plus');
        this.input = this.querySelector('.dl-product-quantity-h-input');

        this.productH = this.closest('dl-product-h');
        this.bindEvents();
    }

    bindEvents() {
        this.minus_btn.addEventListener('click', this.minus.bind(this));
        this.plus_btn.addEventListener('click', this.plus.bind(this));
        this.input.addEventListener('blur', this.oninput.bind(this));
    }

    changeInputValue(value) {
        this.input.value = value;
        this.productH.setTotal();
    }

    plus(e) {
        if (e) {
            e.stopPropagation();
        }
        let value = this.input.value;
        value++;
        value = value > 9 ? 9 : value;
        this.changeInputValue(value);
    }

    oninput() {
        let value = this.input.value;
        value = isNumeric(value) ? value : 1;
        value = value < 1 ? 1 : value > 9 ? 9 : value;
        this.changeInputValue(value);
    }

    minus(e) {
        if (e) {
            e.stopPropagation();
        }
        let value = this.input.value;
        value--;
        value = value < 1 ? 1 : value;
        this.changeInputValue(value);
    }

    getQuantity() {
        return Number(this.input.value);
    }
}
customElements.define('dl-product-quantity-h', DlProductQuantityH);

class DlCopyCouponH extends HTMLElement {
    constructor() {
        super();

        this.btn = this.querySelector('.dl-copy-coupon-h-copy');
        this.code = this.btn.dataset.dlCoupon;
        this.copied = this.querySelector('.dl-copy-coupon-h-copied');

        this.bindEvents();
    }

    bindEvents() {
        this.btn.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
        if (DlCopyCouponH.copyText(this.code)) {
            this.showCopied();
            setTimeout(() => {
                this.hideCopied();
            }, 1500);
        }
    }

    showCopied() {
        this.copied.classList.add('dl-show');
    }

    hideCopied() {
        this.copied.classList.remove('dl-show');
    }

    static copyText(text) {
        let result = true;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(() => {
            }).catch(err => {
                console.error('复制文本失败', err);
                result = false;
            });
        } else {
            var tempInput = document.createElement("input");
            tempInput.type = "hidden";
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            tempInput.setSelectionRange(0, 99999);
            document.execCommand("copy");
            document.body.removeChild(tempInput);
        }
        return result;
    }
}
customElements.define('dl-copy-coupon-h', DlCopyCouponH);

class DlProductAddOnsHPartCBX extends DlCheckboxH {
    constructor() {
        super();
        this.main = this.closest('.dl-product-add-ons-h-part');
        this.main_items = this.main.querySelectorAll('.dl-product-add-ons-h-part-item');
        this.productH = this.closest('dl-product-h');
    }

    verifyOptionSelected() {
        this.main_items.forEach(option => {
            if (option.querySelector(`${this.tagName} .dl-selected`)) {
                option.classList.add('dl-selected');
            } else {
                option.classList.remove('dl-selected');
            }
        })
    }

    selected() {
        super.selected();
        this.verifyOptionSelected();
        this.productH.setTotal();
    }

    unSelected() {
        super.unSelected();
        this.verifyOptionSelected();
        this.productH.setTotal();
    }
}

class DlProductSubscribeHItemCBX extends DlProductAddOnsHPartCBX {
    constructor() {
        super();
    }
}
customElements.define('dl-product-subscribe-h-item-cbx', DlProductSubscribeHItemCBX)

class DlProductSubscribeHItemPlanCBX extends DlCheckboxH {
    constructor() {
        super();
        this.subscribeItem = this.closest('.dl-product-subscribe-h-item');
        this.subscribeItemPrice = this.subscribeItem.querySelector('.dl-product-subscribe-h-item-price');
        this.variantPrice = this.subscribeItem.dataset.dlVariantPrice;

        this.productH = this.closest('dl-product-h');
    }


    handleClick() {
        if (!this.container.hasAttribute('disabled')) {
            this.selected();
            this.setPrice();
        }

        this.productH.setTotal();
    }

    getPrice() {
        return Number(this.variantPrice);
    }

    setPrice() {
        this.subscribeItemPrice.innerHTML = formatMoney(this.getPrice());
    }
}
customElements.define('dl-product-subscribe-h-item-plan-cbx', DlProductSubscribeHItemPlanCBX);

class DlProductSubscribeHItemPlanCBXSelect extends DlProductSubscribeHItemPlanCBX {
    constructor() {
        super();
        this.planId = this.querySelector('.dl-product-subscribe-h-item-plan-select-item').dataset.dlPlanId;
        this.select = this.querySelector('select');
        this.bindEvents();
    }

    bindEvents() {
        this.select.addEventListener('change', this.selectChange.bind(this));
    }

    selectChange(e) {
        let selectTarget = e.target;
        this.select.querySelectorAll('option').forEach((option, index) => {
            if (index == selectTarget.selectedIndex) {
                option.classList.add('dl-selected')
                this.planId = option.dataset.dlPlanId;
            } else {
                option.classList.remove('dl-selected');
            }
        });
        this.productH.setTotal();
    }

    getPrice() {
        let price = this.variantPrice;
        let plan = this.querySelector('.dl-product-subscribe-h-item-plan-select-item.dl-selected');
        let plan_type = plan.dataset.dlPlanPriceAjustmentType;
        let plan_value = plan.dataset.dlPlanPriceAjustmentValue;
        switch (plan_type) {
            case 'percentage':
                price = price * (100 - plan_value) / 100.0;
                break;
        }
        return Number(price);
    }
}
customElements.define('dl-product-subscribe-h-item-plan-cbx-select', DlProductSubscribeHItemPlanCBXSelect);

class DlProductBundleHItemCBX extends DlProductAddOnsHPartCBX {
    constructor() {
        super()
    }
}
customElements.define('dl-product-bundle-h-item-cbx', DlProductBundleHItemCBX);

class DlProductSubscribeH extends HTMLElement {
    constructor() {
        super();
        this.items = this.querySelectorAll('.dl-product-subscribe-h-item');
        this.itemPlans = this.querySelectorAll('.dl-product-subscribe-h-item-plan');
        this.setitemPlanMaxHeight();
        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('resize', this.resize.bind(this));
    }

    getResult() {
        let result = null
        let selectedItem = this.querySelector('.dl-product-subscribe-h-item.dl-selected');
        if (selectedItem != null) {
            let subscribePlan = selectedItem.querySelector('.dl-product-subscribe-h-item-plan-main .dl-checkbox-h.dl-selected').parentNode;
            result = {
                id: selectedItem.dataset.dlVariantId,
                price: subscribePlan.getPrice(),
                plan_id: subscribePlan.planId
            }
        }
        return result;
    }

    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            this.setitemPlanMaxHeight();
        }, 200);
    }

    setitemPlanMaxHeight() {
        this.setitemPlanMaxHeightInterval = setInterval(() => {
            this.itemPlans.forEach(plan => {
                const originalMaxHeight = plan.style.maxHeight;
                //plan.style.maxHeight = '0px';
                const height = plan.scrollHeight;
                if (height != 0) {
                    clearInterval(this.setitemPlanMaxHeightInterval);
                    //plan.style.maxHeight = originalMaxHeight;
                    plan.style.setProperty('--dl-max-height', `${height}px`)
                    //console.log('originalMaxHeight',originalMaxHeight,'aaaa');
                }
            })
        }, 10);
    }
}
customElements.define('dl-product-subscribe-h', DlProductSubscribeH);

class DlProductBundleH extends HTMLElement {
    constructor() {
        super();
        this.main = this.querySelector('.dl-product-bundle-h');
    }

    getResult() {
        let result = [];
        let selectedItems = this.querySelectorAll('.dl-product-bundle-h-item.dl-selected');
        selectedItems.forEach(s_item => {
            result.push({
                id: s_item.dataset.dlVariantId,
                price: Number(s_item.dataset.dlVariantPrice)
            });
        })
        return result;
    }

    getCodeWithCondition() {
        let result = {};
        result.code = this.main.dataset.dlCode;
        result.product = dl_product.id;
        result.variants = [];
        this.querySelectorAll('.dl-product-bundle-h-item').forEach(item => {
            result.variants.push(item.dataset.dlVariantId);
        });
        return result;
    }

    getDiscunt() {
        return this.main.dataset.dlDiscount;
    }

}
customElements.define('dl-product-bundle-h', DlProductBundleH);

class DlProductH extends HTMLElement {
    constructor() {
        super();

        this.mainContainer = this.querySelector('.dl-product-h-main');

        this.galleryContainerMain = this.querySelector('.dl-product-media-gallery-h-main');

        this.variantPicker = this.querySelector('dl-product-variant-picker-h');
        this.quantity = this.querySelector('dl-product-quantity-h');
        this.copyCoupon = this.querySelector('dl-copy-coupon-h');
        this.subscribe = this.querySelector('dl-product-subscribe-h');
        this.bundle = this.querySelector('dl-product-bundle-h');

        this.addtoCartBar = this.querySelector('dl-product-addtocart-bar-h');
        this.bindEvents();

        setTimeout(() => {
            this.isReachBottom();
        });
    }

    bindEvents() {
        window.addEventListener('scroll', this.isReachBottom.bind(this));
    }

    isReachBottom() {
        const rect = this.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        const addtocarbarHeight = this.addtoCartBar.container.offsetHeight;
        const extraHeight = Number(document.documentElement.style.getPropertyValue('--extra-height').trim().replace('px', ''));
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;

        let isBottom = (rect.bottom >= 0 && rect.bottom <= windowHeight - addtocarbarHeight) || rect.bottom < 0;
        if (scrollPosition >= extraHeight) {
            if (isBottom) {
                this.galleryContainerMain.classList.remove('dl-fixed');
                this.galleryContainerMain.classList.add('dl-reach-bottom');
            } else {
                this.galleryContainerMain.classList.add('dl-fixed');
                this.galleryContainerMain.classList.remove('dl-reach-bottom');
            }
        } else {
            this.galleryContainerMain.classList.remove('dl-fixed');
        }
    }

    getSelectVariant() {
        if (this.variantPicker) {
            return this.variantPicker.getSelectVariant();
        } else {
            return dl_product.variants[0];
        }
    }

    getTotal() {
        let variant = this.getSelectVariant();
        let variant_quantity = this.quantity.getQuantity();
        let variant_total = variant.price * variant_quantity;
        //console.log('variant_total', variant_total);

        let subscribe_total = 0;
        if (this.subscribe) {
            let subscribe_result = this.subscribe.getResult();
            if (subscribe_result != null)
                subscribe_total = subscribe_result.price;
        }
        //console.log('subscribe_total', subscribe_total);

        let bundle_total = 0;
        if (this.bundle) {
            let bundle_results = this.bundle.getResult();
            bundle_results.forEach(bundle_item => {
                bundle_total += bundle_item.price;
            })

            if (bundle_results.length > 0) {
                let bundle_discount = this.bundle.getDiscunt();
                if (!isNaN(bundle_discount)) {
                    bundle_discount = 1 - bundle_discount / 100;
                    let _variant_price = Math.ceil(multiply(variant.price, bundle_discount));
                    variant_total = _variant_price * variant_quantity;
                }
            }
        }
        //console.log('bundle_total', bundle_total);

        let total = variant_total + subscribe_total + bundle_total;
        return total;
    }

    setTotal() {
        if (this.addtoCartBar) {
            this.addtoCartBar.setTotal();
        }
    }

    buidlForm() {
        let items = [];
        let variant = this.getSelectVariant();
        let quantity = this.quantity.getQuantity();
        items.push({
            id: variant.id,
            quantity: quantity
        });

        if (this.subscribe) {
            let subscribe_result = this.subscribe.getResult();
            if (subscribe_result != null) {
                items.push({
                    id: subscribe_result.id,
                    quantity: 1,
                    selling_plan: subscribe_result.plan_id
                })
            }
        }

        if (this.bundle) {
            let bundle_results = this.bundle.getResult();
            bundle_results.forEach(bundle_item => {
                items.push({
                    id: bundle_item.id,
                    quantity: 1
                });
            });
            if (bundle_results.length > 0) {
                let bundle_code = this.bundle.getCodeWithCondition();
                DlCartDiscountCode.setDiscountCode(bundle_code);
            }
        }

        let formData = {
            items: items
        };
        if (document.querySelector('cart-drawer')) {
            formData.sections = document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id);
            formData.sections_url = window.location.pathname;
        }
        return formData;
    }
}
customElements.define('dl-product-h', DlProductH);

class DlProductAddtocartBarH extends HTMLElement {
    constructor() {
        super();
        this.setInfo();

        this.productH = this.closest('dl-product-h');
        this.totalSpan = this.querySelector('.dl-product-addtocart-bar-h-subtotal-value');
        this.setTotal();


        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButtonContainer = this.querySelector('.dl-product-addtocart-bar-h-btn');
        this.submitButton = this.querySelector('.dl-product-form__submit-button-h');

        this.container = this.querySelector('.dl-product-addtocart-bar-h');
        this.bindEvents();
        this.setFooterHeight();
    }

    bindEvents() {
        this.submitButton.addEventListener('click', this.submit.bind(this));
        window.addEventListener('resize', this.resize.bind(this));
    }

    setInfo() {
        let info = this.querySelector('.dl-product-addtocart-bar-h');
        let info_start = this.querySelector('.dl-product-addtocart-bar-h-info-start');
        let info_end = this.querySelector('.dl-product-addtocart-bar-h-info-end');

        let start_time = info.dataset.dlStart;
        let interval = info.dataset.dlInterval;

        var currentDate = new Date();
        let start_date = new Date(currentDate.getTime() + (start_time * 24 * 60 * 60 * 1000));
        let end_date = new Date(start_date.getTime() + (interval * 24 * 60 * 60 * 1000));

        let start_date_format = (start_date.getMonth() + 1) + '/' + start_date.getDate();
        let end_date_format = (end_date.getMonth() + 1) + '/' + end_date.getDate() + '/' + end_date.getFullYear();

        info_start.innerHTML = start_date_format;
        info_end.innerHTML = end_date_format;
    }

    setTotal() {
        this.totalSpan.innerHTML = formatMoney(this.productH.getTotal());
    }

    setFooterHeight() {
        document.querySelector('html').style.setProperty('--addtocarbar-height', `${this.container.offsetHeight}px`);
    }

    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            this.setFooterHeight();
        }, 200);
    }

    submit() {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.cart) {
            this.cart.setActiveElement(document.activeElement);
        }

        publish(PUB_SUB_EVENTS.mainAddToCartStart, {})
        let formData = this.productH.buidlForm();
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((response) => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: this.productH.getSelectVariant().id,
                    cartData: response,
                });
                if (this.cart) {
                    this.cart.renderContents(response);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            }).finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
            });
    }

    enabled() {
        console.log('enabled');
        this.submitButton.removeAttribute('disabled');
        this.submitButtonContainer.removeAttribute('disabled');
    }

    disabled() {
        console.log('disabled');
        this.submitButton.setAttribute('disabled', true);
        this.submitButtonContainer.setAttribute('disabled', true);
    }
}
customElements.define('dl-product-addtocart-bar-h', DlProductAddtocartBarH);

class DlProductMediaGalleryPopH extends HTMLElement {
    constructor() {
        super();

        this.parrent = this.closest('.dl-product-h-gallery');

        this.enterBtn = this.querySelector('.dl-product-media-gallery-pop-h-enter');
        this.closeBtn = this.querySelector('.dl-product-media-gallery-pop-h-pop-close');
        this.popBase = this.querySelector('.dl-product-media-gallery-pop-h-pop-base');

        this.mainGlideContainer = this.querySelector('.dl-product-media-gallery-pop-h-main-image');

        this.thumbnailGlideContainer = this.querySelector('.dl-product-media-gallery-pop-h-main-thumbnail');
        this.thumbnailGlideSlides = this.querySelectorAll('.dl-product-media-gallery-pop-h-main-thumbnail .glide__slide');

        this.initializeGlide();
        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('resize', this.resize.bind(this));

        this.enterBtn.addEventListener('click', this.show.bind(this));
        this.closeBtn.addEventListener('click', this.hide.bind(this));

        this.thumbnailGlideSlides.forEach(slide => {
            slide.addEventListener('click', this.thumbnailClick.bind(this));
        })
    }

    show() {
        DlFullPageLockH.lock();
        this.popBase.classList.add('dl-show');
        this.parrent.style.zIndex = 99999;
        this.initializeGlide();
    }

    hide() {
        DlFullPageLockH.unlock();
        this.popBase.classList.remove('dl-show');
        this.parrent.style.zIndex = 'auto';
    }

    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            this.initializeGlide();
        }, 200);
    }

    setSelectedThumbnail(index) {
        this.thumbnailGlideSlides.forEach((e, i) => {
            if (i != index) {
                e.classList.remove('dl-selected');
            } else {
                e.classList.add('dl-selected');
            }
        })
    }

    changeImage(index) {
        this.mainGlide.go('=' + index);
    }

    thumbnailClick(e) {
        let elem = e.currentTarget;
        let index = Number(elem.dataset.dlIndex);
        this.setSelectedThumbnail(index);
        this.fromThumbnail = true;
        this.changeImage(index);
    }

    initializeGlide() {
        this.initializeMainGlide();
        this.initializeThumbnailGlide();
    }

    initializeMainGlide() {
        let index = 0;
        if (this.mainGlide) {
            index = this.mainGlide.index;
            this.mainGlide.destroy();
        }

        this.mainGlide = new Glide(this.mainGlideContainer, {
            type: 'carousel',
            startAt: index,
            perView: 1,
        });

        this.mainGlide.on('run', () => {
            this.setSelectedThumbnail(this.mainGlide.index);
            if (this.thumbnailGlideSlides.length > 12 && !this.fromThumbnail) {
                this.thumbnailGlide.go('=' + this.mainGlide.index);
            }
            this.fromThumbnail = false;
        })

        this.mainGlide.mount();
    }

    initializeThumbnailGlide() {
        let index = 0;
        if (this.thumbnailGlide) {
            index = this.thumbnailGlide.index;
            this.thumbnailGlide.destroy();
        }

        this.thumbnailGlide = new Glide(this.thumbnailGlideContainer, {
            type: 'slider',
            startAt: index,
            perView: 12,
            gap: 8,
            swipeThreshold: false,
            dragThreshold: false,
            bound: true
        })

        this.thumbnailGlide.on('mount.after', () => {
            let thumbnailGlideSlidesCount = this.thumbnailGlideSlides.length;
            let width = this.querySelector('.dl-product-media-gallery-pop-h-main-thumbnail-items').offsetWidth;
            width = (width - (thumbnailGlideSlidesCount * 8)) / thumbnailGlideSlidesCount;
            this.thumbnailGlideSlides.forEach(slide => {
                slide.style.height = width + 'px';
            })
        })

        this.thumbnailGlide.mount();
    }
}
customElements.define('dl-product-media-gallery-pop-h', DlProductMediaGalleryPopH);

class DlProductMediaGalleryMH extends HTMLElement {
    constructor() {
        super();

        this.glideContainer = this.querySelector('.dl-product-media-gallery-m-h-main');
        this.bullet = this.querySelectorAll('.dl-product-media-gallery-m-h-main-bullet');

        this.lastWindowWidth = window.innerWidth;
        this.initializeGlide();
        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            if (this.lastWindowWidth != window.innerWidth) {
                this.initializeGlide();
                this.lastWindowWidth = window.innerWidth;
            }
        }, 200);
    }

    initializeGlide() {
        if (this.glide) {
            this.glide.destroy();
        }

        this.glide = new Glide(this.glideContainer, {
            type: 'carousel',
            perView: 1,
        })

        this.glide.on('run', () => {
            this.bullet.forEach((e, i) => {
                if (i == this.glide.index) {
                    e.classList.add('dl-selected');
                } else {
                    e.classList.remove('dl-selected');
                }
            })
        })

        this.glide.mount();
    }
}
customElements.define('dl-product-media-gallery-m-h', DlProductMediaGalleryMH);

class DlInfoIconH extends HTMLElement {
    constructor() {
        super();

        this.main = this.querySelector('.dl-info-icon-h');
        this.msg = this.querySelector('.dl-info-icon-h-msg');
        this.btn = this.querySelector('.dl-info-icon-h-btn');

        this.init();
        this.bindEvents()
    }

    bindEvents() {
        this.btn.addEventListener('click', this.btnClick.bind(this));
        document.addEventListener('click', this.documentClick.bind(this));
    }

    documentClick(event) {
        if (this.main.classList.contains('dl-show') && !this.msg.contains(event.target) && !this.btn.contains(event.target)) {
            this.hide();
        }
    }

    btnClick(e) {
        e.stopPropagation();
        if (this.main.classList.contains('dl-show')) {
            this.hide();
        } else {
            this.show();
        }
    }

    init() {
        if (this.msg.innerHTML.trim() != '') {
            this.main.classList.add('dl-showing');
        }
    }

    show() {
        this.main.classList.add('dl-show');
    }

    hide() {
        this.main.classList.remove('dl-show');
    }
}
customElements.define('dl-info-icon-h', DlInfoIconH);